var _metadata, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFrutiger45Light = function SvgFrutiger45Light(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("version", null, "1.0"), /*#__PURE__*/React.createElement("id", null), /*#__PURE__*/React.createElement("vendor", null, "Monotype Imaging Inc."), /*#__PURE__*/React.createElement("credits", null, /*#__PURE__*/React.createElement("name", null, "Fonts.com WebFonts"), /*#__PURE__*/React.createElement(URL, null, "http://webfonts.fonts.com"), /*#__PURE__*/React.createElement("role", null, "Home of the Web fonts")), /*#__PURE__*/React.createElement("license", null, /*#__PURE__*/React.createElement(URL, null, "http://webfonts.fonts.com/Legal")), /*#__PURE__*/React.createElement("copyright", null), /*#__PURE__*/React.createElement("trademark", null), /*#__PURE__*/React.createElement("licensee", null, /*#__PURE__*/React.createElement("name", null)))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    horizAdvX: 505,
    id: "FrutigerLTW01-45Light"
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "",
    panose1: "2 11 3 3 3 5 4 2 2 4",
    ascent: 927,
    descent: -250,
    unitsPerEm: 1000,
    alphabetic: 0
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\n"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\r",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: " ",
    horizAdvX: 278
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "!",
    horizAdvX: 389,
    d: "M154 84H235V0H154V84ZM223 169H166L154 698H235L223 169Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\"",
    horizAdvX: 556,
    d: "M314 698H377V480H314V698ZM179 698H242V480H179V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "#",
    horizAdvX: 556,
    d: "M358 425H228L207 273H337L358 425ZM138 219H34V273H145L167 425H60V479H174L205 698H266L235 479H365L396 698H457L426 479H522V425H419L398 273H494V219H390L359 0H298L329 219H199L168 0H107L138 219Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "$",
    horizAdvX: 556,
    d: "M308 771V710Q334 710 371 706Q408 700 443 687L432 624Q383 649 308 650V385Q340 369 370 351Q399 333 422 309Q446 286 460 256Q474 225 474 185Q473 101 425 55Q376 9 308 -6V-89H257V-11Q251 -12 245 -12Q143 -10 87 18L94 89Q153 48 248 48Q252 48 257 49V336Q227 354 196 373Q166 391 141 414Q86 458 85 528Q86 602 135 648Q182 694 257 706V771H308ZM257 645Q215 638 185 610Q154 582 154 530Q154 492 185 465Q213 437 257 413V645ZM308 57Q352 69 378 103Q404 136 405 191Q404 228 378 256Q351 283 308 307V57H308Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "%",
    horizAdvX: 1000,
    d: "M677 720H735L322 -22H264L677 720ZM168 518Q168 495 173 472Q178 449 188 429Q199 409 218 398Q236 385 263 385Q292 385 311 398Q329 409 339 429Q350 449 354 472Q358 495 358 518Q358 542 354 566Q350 589 339 609Q329 629 311 640Q292 651 263 651Q236 651 218 640Q199 629 188 609Q178 589 173 566Q168 542 168 518ZM105 518Q105 601 143 652Q181 704 263 705Q347 704 385 652Q421 601 421 518Q421 437 385 385Q347 332 263 331Q181 332 143 385Q105 437 105 518ZM642 180Q642 157 647 134Q652 111 662 91Q673 71 692 60Q710 47 737 47Q766 47 785 60Q803 71 813 91Q824 111 828 134Q832 157 832 180Q832 204 828 228Q824 251 813 271Q803 291 785 302Q766 313 737 313Q710 313 692 302Q673 291 662 271Q652 251 647 228Q642 204 642 180ZM579 180Q579 263 617 314Q655 366 737 367Q821 366 859 314Q895 263 895 180Q895 99 859 47Q821 -6 737 -7Q655 -6 617 47Q579 99 579 180Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "&",
    horizAdvX: 667,
    d: "M193 554Q194 514 219 479Q243 443 272 412Q296 424 320 436Q343 448 363 464Q383 481 395 503Q407 525 407 555Q404 655 308 656Q287 656 267 650Q246 644 229 631Q194 605 193 554ZM250 347Q199 327 161 286Q120 245 119 186Q120 115 169 79Q216 42 281 42Q330 42 376 65Q422 87 453 123L250 347H250ZM492 171Q553 268 552 383H612Q612 242 534 131L653 2H565L491 80Q404 -13 279 -12Q187 -12 121 35Q51 83 50 183Q51 263 98 312Q145 360 215 386Q182 423 154 465Q125 506 124 558Q125 633 184 672Q240 710 312 710Q377 710 426 675Q475 639 476 566Q476 526 462 498Q448 468 424 447Q400 426 370 410Q340 392 308 376L492 171H492Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "'",
    horizAdvX: 278,
    d: "M108 698H171V480H108V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "(",
    horizAdvX: 278,
    d: "M213 -140Q146 -37 95 73Q43 183 42 308Q43 434 95 544Q146 655 213 756H255Q199 652 154 541Q106 429 105 308Q106 187 154 76Q199 -35 255 -140H213Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ")",
    horizAdvX: 278,
    d: "M65 756Q134 655 184 544Q234 434 236 308Q234 183 184 73Q134 -37 65 -140H23Q81 -35 126 76Q172 187 173 308Q172 429 126 541Q81 652 23 756H65Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "*",
    horizAdvX: 556,
    d: "M307 698L300 545L445 601L464 543L317 501L414 382L364 344L278 475L194 344L145 382L239 501L92 543L109 601L256 545L249 698H307Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "+",
    horizAdvX: 600,
    d: "M46 288H265V507H334V288H553V219H334V0H265V219H46V288Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ",",
    horizAdvX: 278,
    d: "M112 84H196L117 -134H54L112 84Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "-",
    horizAdvX: 333,
    d: "M41 304H292V235H41V304Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ".",
    horizAdvX: 278,
    d: "M98 84H179V0H98V84Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "/",
    horizAdvX: 278,
    d: "M240 710H309L38 -12H-31L240 710Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 0,
    horizAdvX: 556,
    d: "M278 705Q348 704 393 673Q438 641 463 589Q509 479 507 349Q507 294 500 233Q492 171 468 117Q445 63 399 29Q353 -6 278 -7Q205 -6 160 29Q114 63 90 117Q67 171 58 233Q48 294 49 349Q47 479 94 589Q119 641 165 673Q210 704 278 705ZM278 645Q224 644 193 616Q160 587 144 541Q128 495 123 445Q118 393 118 349Q118 305 123 254Q128 204 144 158Q160 112 193 84Q224 53 278 53Q333 53 365 84Q397 112 413 158Q429 204 435 254Q438 305 438 349Q438 393 435 445Q429 495 413 541Q397 587 365 616Q333 644 278 645Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 1,
    horizAdvX: 556,
    d: "M281 698H343V0H274V620L161 521L123 566L281 698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 2,
    horizAdvX: 556,
    d: "M50 60L210 237Q276 308 326 382Q376 455 378 519Q377 576 343 610Q309 644 255 645Q165 644 87 595L75 658Q115 678 162 692Q208 705 251 705Q339 705 395 661Q452 616 453 522Q451 443 391 359Q332 274 261 198L135 60H469V0H50V60Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 3,
    horizAdvX: 556,
    d: "M150 392H168Q205 392 246 397Q287 401 323 414Q360 428 383 456Q405 484 405 532Q405 562 391 584Q377 605 354 619Q305 645 245 645Q163 644 89 608L83 673Q162 704 252 705Q342 705 407 666Q472 625 474 532Q473 469 434 426Q394 382 329 365V363Q400 359 437 312Q474 266 474 194Q472 99 401 47Q330 -6 222 -7Q133 -8 50 21L58 87Q102 68 146 61Q188 53 226 53Q292 53 348 88Q403 122 405 200Q405 245 386 272Q367 298 338 311Q309 325 277 329Q243 332 214 332H150V392Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 4,
    horizAdvX: 556,
    d: "M23 229L337 698H425V221H528V161H425V0H356V161H23V229ZM356 629H354L86 221H356V629Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 5,
    horizAdvX: 556,
    d: "M458 638H169L164 414Q181 420 206 425Q231 429 270 429Q485 426 489 225Q488 109 419 52Q350 -7 235 -7Q158 -7 86 18V89Q157 53 235 53Q307 53 362 92Q418 131 420 211Q420 370 245 369Q164 369 94 347L101 698H458V638Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 6,
    horizAdvX: 556,
    d: "M290 381Q215 380 174 339Q131 296 131 226Q131 159 168 108Q205 54 281 53Q358 54 399 101Q438 146 438 218Q437 378 290 381ZM279 -7Q210 -6 167 23Q123 51 98 98Q74 145 65 204Q55 262 55 324Q54 487 125 594Q196 703 370 705Q427 704 482 689L476 623Q427 644 361 645Q294 646 249 622Q203 598 175 555Q148 514 136 462Q124 409 124 355H126Q154 400 198 421Q241 441 290 441Q326 441 364 432Q402 422 434 398Q467 374 487 332Q507 289 507 223Q506 120 447 58Q388 -6 279 -7Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 7,
    horizAdvX: 556,
    d: "M416 638H58V698H484V638L214 0H138L416 638Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 8,
    horizAdvX: 556,
    d: "M137 536Q137 506 152 484Q166 461 187 443Q209 425 233 412Q257 399 278 388Q329 412 372 447Q394 465 406 488Q418 509 418 536Q417 592 373 619Q330 645 278 645Q222 645 181 618Q138 591 137 536ZM441 185Q441 218 425 242Q410 266 384 282Q360 300 332 313Q303 325 278 337Q248 326 219 314Q190 301 167 283Q144 266 130 241Q115 216 115 179Q115 151 130 128Q144 104 167 87Q216 53 278 53Q342 52 391 83Q440 114 441 185ZM68 542Q68 587 90 618Q110 649 142 668Q210 705 278 705Q363 705 424 667Q485 627 487 542Q485 478 441 435Q396 390 344 363Q418 340 464 300Q509 260 510 179Q508 78 436 36Q366 -7 278 -7Q191 -7 121 39Q88 61 68 97Q46 131 46 179Q47 258 93 300Q138 341 207 363Q152 388 111 431Q69 474 68 542Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 9,
    horizAdvX: 556,
    d: "M266 317Q342 317 384 361Q425 402 425 472Q425 540 390 592Q353 644 275 645Q198 644 159 599Q118 552 118 480Q118 319 266 317ZM277 705Q347 705 391 677Q436 649 459 602Q484 555 493 496Q501 437 501 374Q502 213 433 105Q361 -5 186 -7Q129 -6 74 9L80 75Q129 53 195 53Q329 57 382 144Q433 232 432 343H430Q403 300 360 279Q316 257 266 257Q231 257 194 268Q156 278 124 302Q92 327 71 369Q49 411 49 475Q49 579 110 642Q170 704 277 705Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ":",
    horizAdvX: 278,
    d: "M98 84H179V0H98V84ZM179 426H98V510H179V426Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ";",
    horizAdvX: 278,
    d: "M179 426H98V510H179V426ZM112 84H196L117 -134H54L112 84Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "<",
    horizAdvX: 600,
    d: "M553 448L123 253L553 58V-8L46 222V284L553 514V448Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "=",
    horizAdvX: 600,
    d: "M46 187H553V118H46V187ZM46 388H553V319H46V388Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ">",
    horizAdvX: 600,
    d: "M47 58L478 253L47 448V514L554 284V222L47 -8V58Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "?",
    horizAdvX: 500,
    d: "M182 84H263V0H182V84ZM86 685Q158 709 232 710Q312 710 367 668Q423 624 424 531Q423 471 398 431Q373 390 339 356Q306 323 281 283Q253 243 253 184V169H190V182Q191 250 217 292Q229 314 244 332Q258 350 273 366Q306 398 330 436Q354 474 355 531Q354 587 320 619Q284 650 229 650Q189 650 156 642Q140 638 123 633Q105 628 89 622L86 685Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "@",
    horizAdvX: 800,
    d: "M531 266Q521 239 521 217Q521 208 527 202Q531 194 543 194Q572 194 599 212Q625 229 645 258Q689 319 690 408Q688 526 603 588Q519 650 401 650Q273 649 191 566Q107 483 106 350Q107 217 191 134Q273 49 401 48Q576 50 665 159H726Q624 -9 401 -12Q221 -9 131 102Q40 208 40 349Q40 491 131 598Q221 707 401 710Q539 710 645 634Q753 557 756 408Q753 280 675 208Q600 134 530 134Q464 134 451 195H449Q432 173 404 154Q376 134 326 134Q266 135 229 179Q191 221 191 284Q191 386 255 469Q317 552 422 555Q494 556 532 478L553 538H616L531 266ZM266 290Q272 195 338 194Q376 194 406 216Q436 237 457 269Q501 338 502 405Q501 457 476 477Q451 495 422 495Q370 494 320 438Q268 382 266 290Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "A",
    horizAdvX: 667,
    d: "M181 247H484L333 632L181 247ZM299 698H377L654 0H582L507 187H155L80 0H13L299 698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "B",
    horizAdvX: 556,
    d: "M151 393H228Q257 393 287 399Q316 404 341 417Q367 432 382 457Q398 483 398 523Q398 562 384 585Q368 607 345 619Q322 631 296 635Q269 638 246 638H151V393ZM149 60H221Q257 60 292 67Q327 73 356 87Q385 102 402 129Q419 156 419 196Q419 243 402 271Q384 299 354 312Q324 326 287 330Q249 333 210 333H149V60ZM80 698H246Q335 699 400 663Q465 625 467 526Q467 393 340 367V365Q407 353 447 311Q487 269 488 199Q486 87 408 43Q372 21 323 10Q275 0 219 0H80V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "C",
    horizAdvX: 667,
    d: "M565 620Q531 638 490 645Q447 650 409 650Q273 648 200 565Q126 482 126 349Q126 215 199 133Q271 49 409 48Q445 48 490 55Q534 61 565 78L569 18Q538 2 492 -5Q445 -12 409 -12Q243 -10 151 88Q57 185 57 349Q58 511 152 610Q245 708 409 710Q443 710 492 705Q540 699 569 684L565 620Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "D",
    horizAdvX: 667,
    d: "M80 698H253Q439 696 522 601Q603 506 602 350Q600 163 489 81Q379 0 202 0H80V698ZM149 60H206Q525 53 533 354Q531 512 451 577Q370 639 250 638H149V60Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "E",
    horizAdvX: 500,
    d: "M86 698H428V638H155V389H414V329H155V60H440V0H86V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "F",
    horizAdvX: 444,
    d: "M77 698H409V638H146V389H397V329H146V0H77V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "G",
    horizAdvX: 722,
    d: "M564 318H402V378H633V31Q529 -13 416 -12Q250 -10 158 88Q64 185 64 349Q65 511 159 610Q252 708 416 710Q459 710 513 703Q566 695 603 677L595 613Q554 635 509 644Q463 650 416 650Q280 648 207 565Q133 482 133 349Q133 215 206 133Q278 49 416 48Q451 48 495 54Q538 58 564 73V318Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "H",
    horizAdvX: 667,
    d: "M88 698H157V389H510V698H579V0H510V329H157V0H88V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "I",
    horizAdvX: 222,
    d: "M77 698H146V0H77V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "J",
    horizAdvX: 333,
    d: "M250 180Q250 98 212 45Q172 -11 86 -12Q49 -12 14 0V61Q45 48 79 48Q137 49 160 88Q181 126 181 178V698H250V180Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "K",
    horizAdvX: 611,
    d: "M95 698H164V385L478 698H568L230 369L597 0H502L164 349V0H95V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "L",
    horizAdvX: 444,
    d: "M80 698H149V60H429V0H80V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "M",
    horizAdvX: 889,
    d: "M86 698H193L448 84L704 698H803V0H734V629H732L478 0H419L157 629H155V0H86V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "N",
    horizAdvX: 667,
    d: "M77 698H164L519 84H521V698H590V0H497L148 602H146V0H77V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "O",
    horizAdvX: 722,
    d: "M361 650Q239 647 181 556Q123 465 123 349Q123 233 181 144Q239 50 361 48Q484 50 542 144Q599 233 599 349Q599 465 542 556Q484 647 361 650ZM54 349Q53 496 129 601Q204 707 361 710Q519 707 595 601Q670 496 668 349Q667 186 590 89Q512 -10 361 -12Q211 -10 134 89Q56 186 54 349Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "P",
    horizAdvX: 500,
    d: "M155 362H203Q243 362 279 367Q315 371 344 384Q373 398 389 426Q405 454 405 500Q403 636 267 638H155V362ZM86 698H258Q469 698 474 500Q473 403 410 353Q348 302 251 302H155V0H86V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Q",
    horizAdvX: 722,
    d: "M361 650Q239 647 181 556Q123 465 123 349Q123 233 181 144Q239 50 361 48Q484 50 542 144Q599 233 599 349Q599 465 542 556Q484 647 361 650ZM542 -130L418 -7Q391 -12 361 -12Q211 -10 134 89Q56 186 54 349Q53 496 129 601Q204 707 361 710Q519 707 595 601Q670 496 668 349Q665 94 487 12L634 -130H542Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "R",
    horizAdvX: 556,
    d: "M88 698H268Q468 701 473 517Q472 449 428 408Q384 366 318 356V354Q358 349 376 328Q386 318 393 303Q401 288 408 270L527 0H451L350 236Q322 301 292 317Q277 326 258 328Q239 329 214 329H157V0H88V698ZM157 389H230Q295 388 348 417Q402 446 404 517Q404 560 390 585Q376 610 352 621Q328 633 296 636Q264 638 228 638H157V389Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "S",
    horizAdvX: 500,
    d: "M67 89Q126 48 221 48Q288 48 333 83Q377 118 378 191Q377 242 328 277Q306 295 277 311Q248 327 218 343Q188 360 160 379Q131 397 108 419Q59 462 58 528Q59 613 123 662Q185 709 279 710Q306 710 343 706Q380 700 416 687L405 624Q354 650 278 650Q251 650 225 645Q199 639 176 624Q155 611 141 588Q127 564 127 530Q127 505 141 484Q155 463 177 447Q200 430 229 415Q257 399 287 382Q350 352 397 306Q420 284 434 254Q447 224 447 185Q445 81 374 34Q304 -12 218 -12Q116 -10 60 18L67 89Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "T",
    horizAdvX: 500,
    d: "M216 638H10V698H491V638H285V0H216V638Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "U",
    horizAdvX: 667,
    d: "M587 244Q586 168 563 118Q538 67 500 39Q461 11 418 0Q374 -12 334 -12Q296 -12 253 0Q209 11 170 39Q132 67 107 118Q81 168 81 244V698H150V244Q150 157 197 104Q244 49 334 48Q426 49 472 104Q518 157 518 244V698H587V244Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "V",
    horizAdvX: 611,
    d: "M340 0H266L6 698H79L304 69L537 698H605L340 0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "W",
    horizAdvX: 944,
    d: "M733 0H651L474 620H472L292 0H209L9 698H80L252 78H254L433 698H516L692 78H694L869 698H935L733 0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "X",
    horizAdvX: 611,
    d: "M267 367L33 698H114L310 416L508 698H585L350 367L604 0H520L307 318L86 0H7L267 367Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Y",
    horizAdvX: 611,
    d: "M271 296L12 698H92L305 357L524 698H599L340 296V0H271V296Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Z",
    horizAdvX: 500,
    d: "M21 60L385 638H30V698H458V638L96 60H470V0H21V60Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "[",
    horizAdvX: 278,
    d: "M69 756H231V708H132V-92H231V-140H69V756Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\\\\\\\",
    horizAdvX: 278,
    d: "M309 -12H240L-31 710H38L309 -12Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "]",
    horizAdvX: 278,
    d: "M209 -140H47V-92H146V708H47V756H209V-140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "^",
    horizAdvX: 600,
    d: "M268 698H332L550 265H479L300 629L121 265H50L268 698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "_",
    horizAdvX: 500,
    d: "M500 -75V-125H0V-75H500Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "`",
    horizAdvX: 222,
    d: "M168 572H122L-4 716H75L168 572Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "a",
    horizAdvX: 500,
    d: "M366 257H348Q307 257 266 255Q223 251 188 238Q153 226 132 201Q109 176 109 134Q109 85 141 64Q171 42 215 42Q270 42 302 64Q333 85 347 114Q362 145 364 175Q366 206 366 226V257ZM372 82H370Q348 37 303 13Q258 -11 208 -12Q155 -11 122 5Q88 20 70 43Q38 93 40 132Q40 196 71 233Q101 270 148 286Q195 303 250 308Q304 311 354 311H366V337Q369 468 250 468Q171 469 100 426V487Q171 520 250 522Q431 524 429 332V107Q428 49 434 0H372V82Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "b",
    horizAdvX: 556,
    d: "M438 255Q438 293 433 331Q426 369 408 399Q392 431 362 449Q332 468 287 468Q245 468 216 449Q187 429 169 397Q135 330 136 255Q135 182 170 114Q188 82 217 63Q245 42 287 42Q332 42 362 63Q392 82 408 112Q426 144 433 182Q438 219 438 255ZM73 750H136V424H138Q142 435 154 452Q165 468 184 483Q204 500 232 511Q260 522 297 522Q409 521 459 447Q507 374 507 255Q507 140 455 65Q402 -10 297 -12Q188 -13 138 81H136V0H73V750Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "c",
    horizAdvX: 444,
    d: "M411 442Q357 467 302 468Q210 467 161 409Q110 350 110 255Q110 166 160 106Q209 43 295 42Q354 42 410 65L416 6Q354 -13 285 -12Q162 -10 102 69Q41 146 41 255Q42 376 111 448Q179 521 293 522Q340 522 371 515Q387 512 399 509Q410 505 416 502L411 442Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "d",
    horizAdvX: 556,
    d: "M118 255Q118 219 125 182Q133 144 149 112Q167 82 196 63Q224 42 269 42Q311 42 341 63Q369 82 387 114Q421 182 420 255Q420 291 413 329Q405 365 387 397Q369 429 341 449Q311 468 269 468Q224 468 196 449Q167 431 149 399Q133 369 125 331Q118 293 118 255ZM483 0H420V81H418Q368 -13 259 -12Q154 -10 102 65Q49 140 49 255Q48 374 98 447Q148 521 259 522Q297 522 325 511Q354 500 373 483Q412 448 418 424H420V750H483V0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "e",
    horizAdvX: 500,
    d: "M390 291Q390 361 361 413Q330 466 260 468Q191 466 151 412Q110 358 110 291H390ZM421 16Q349 -11 273 -12Q148 -10 94 65Q40 138 41 255Q42 374 101 448Q158 521 256 522Q363 520 412 447Q459 375 459 269V237H110Q110 154 153 100Q195 43 278 42Q315 42 356 55Q397 66 421 80V16Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "f",
    horizAdvX: 333,
    d: "M122 456H19V510H122V547Q122 588 126 627Q128 665 141 695Q154 726 182 744Q209 762 257 762Q273 762 290 761Q307 758 316 752L312 697Q291 708 262 708Q231 708 215 694Q198 678 192 655Q186 632 186 606Q185 579 185 554V510H300V456H185V0H122V456Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "g",
    horizAdvX: 556,
    d: "M483 42Q483 -67 430 -140Q375 -214 244 -216Q194 -215 152 -205Q111 -195 90 -189L95 -126Q158 -160 245 -162Q306 -161 341 -140Q377 -120 394 -84Q412 -48 417 -1Q421 46 421 100H419Q365 -2 264 0Q144 3 96 86Q71 124 61 168Q49 212 49 255Q48 374 98 447Q148 521 259 522Q309 522 347 511Q384 497 418 452H420V510H483V42ZM118 255Q117 177 152 118Q186 56 265 54Q350 56 386 120Q420 182 420 255Q420 350 388 408Q355 467 269 468Q224 468 196 449Q167 431 149 399Q133 369 125 331Q118 293 118 255Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "h",
    horizAdvX: 556,
    d: "M79 750H142V424H144Q165 467 206 495Q247 521 303 522Q405 521 442 462Q478 402 477 305V0H414V304Q414 338 410 368Q406 397 393 419Q369 467 293 468Q211 466 176 405Q141 344 142 273V0H79V750Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "i",
    horizAdvX: 222,
    d: "M142 646H79V730H142V646ZM79 510H142V0H79V510Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "j",
    horizAdvX: 222,
    d: "M142 646H79V730H142V646ZM-28 -156Q-11 -161 10 -162Q57 -161 69 -132Q80 -104 79 -64V510H142V-72Q143 -135 120 -174Q107 -193 85 -204Q61 -216 27 -216Q-13 -215 -28 -211V-156Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "k",
    horizAdvX: 500,
    d: "M79 750H142V301L370 510H451L202 284L481 0H394L142 262V0H79V750Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "l",
    horizAdvX: 222,
    d: "M79 750H142V0H79V750Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "m",
    horizAdvX: 833,
    d: "M695 0V339Q695 367 691 391Q685 414 672 431Q660 449 639 459Q618 468 587 468Q534 468 493 424Q451 378 450 282V0H387V339Q387 367 383 391Q377 414 364 431Q352 449 331 459Q310 468 279 468Q226 468 185 424Q143 378 142 282V0H79V390Q79 449 75 510H136V424L138 423Q145 437 157 454Q167 471 185 486Q203 501 230 512Q257 522 297 522Q315 522 336 518Q356 514 376 502Q396 491 411 470Q426 448 432 414H434Q453 460 495 491Q536 521 597 522Q675 521 717 474Q758 428 758 351V0H695Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "n",
    horizAdvX: 556,
    d: "M79 390Q79 449 75 510H136V419H138Q147 437 159 455Q171 473 189 488Q208 504 236 513Q264 522 303 522Q397 521 438 466Q477 412 477 326V0H414V310Q414 383 387 426Q358 467 293 468Q209 466 175 408Q157 381 150 349Q142 316 142 282V0H79V390Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "o",
    horizAdvX: 556,
    d: "M109 255Q109 164 153 105Q195 43 278 42Q361 43 405 105Q447 164 447 255Q447 346 405 407Q361 467 278 468Q195 467 153 407Q109 346 109 255ZM40 255Q40 364 98 441Q156 520 278 522Q402 520 460 441Q516 364 516 255Q516 148 460 70Q402 -10 278 -12Q156 -10 98 70Q40 148 40 255Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "p",
    horizAdvX: 556,
    d: "M438 255Q438 293 433 331Q426 369 408 399Q392 431 362 449Q332 468 287 468Q245 468 217 449Q188 429 170 397Q152 365 145 329Q136 291 136 255Q135 182 170 114Q188 82 217 63Q245 42 287 42Q332 42 362 63Q392 82 408 112Q426 144 433 182Q438 219 438 255ZM73 510H136L132 417H134Q140 428 152 447Q163 464 182 481Q201 498 229 511Q257 522 297 522Q409 521 459 447Q507 374 507 255Q507 140 455 65Q402 -10 297 -12Q181 -12 138 87H136V-210H73V510Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "q",
    horizAdvX: 556,
    d: "M118 255Q118 219 125 182Q133 144 149 112Q167 82 196 63Q224 42 269 42Q311 42 341 63Q369 82 387 114Q421 182 420 255Q420 291 413 329Q405 365 387 397Q369 429 341 449Q311 468 269 468Q224 468 196 449Q167 431 149 399Q133 369 125 331Q118 293 118 255ZM483 -210H420V87H418Q375 -12 259 -12Q154 -10 102 65Q49 140 49 255Q48 374 98 447Q148 521 259 522Q299 522 329 511Q357 499 375 482Q394 465 404 450Q414 435 418 427H420V510H483V-210Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "r",
    horizAdvX: 333,
    d: "M79 396Q79 467 75 510H138V412H140Q158 457 191 489Q223 521 271 522Q296 521 315 516V450Q294 456 269 456Q232 455 208 438Q184 420 169 389Q155 359 149 324Q142 287 142 252V0H79V396Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "s",
    horizAdvX: 389,
    d: "M40 74Q98 43 173 42Q220 42 253 67Q285 90 286 133Q285 178 249 204Q213 229 164 249Q141 260 120 272Q99 284 80 299Q63 315 52 336Q41 356 41 383Q42 459 93 491Q142 522 207 522Q229 522 264 518Q299 512 333 499L327 444Q272 467 214 468Q165 468 136 450Q121 441 113 425Q104 409 104 383Q104 367 115 353Q126 340 144 329Q162 319 185 308Q208 298 230 286Q280 265 317 230Q354 195 355 133Q355 93 339 66Q322 38 296 21Q240 -12 177 -12Q103 -12 34 12L40 74H40Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "t",
    horizAdvX: 333,
    d: "M299 456H183V126Q183 91 199 67Q214 42 251 42Q285 42 309 54L313 2Q302 -2 282 -7Q261 -12 236 -12Q195 -12 171 2Q148 16 136 39Q126 63 123 93Q120 123 120 158V456H20V510H120V633L183 655V510H299V456Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "u",
    horizAdvX: 556,
    d: "M477 120Q476 62 481 0H420V91H418Q411 74 399 57Q387 39 368 23Q349 8 321 -1Q293 -12 253 -12Q160 -11 119 44Q78 98 79 184V510H142V200Q142 127 171 86Q199 42 263 42Q306 42 336 60Q366 77 382 104Q400 132 407 164Q414 196 414 228V510H477V120Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "v",
    horizAdvX: 444,
    d: "M256 0H182L9 510H78L219 69H221L369 510H435L256 0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "w",
    horizAdvX: 778,
    d: "M603 0H527L388 441H386L247 0H171L7 510H76L210 69H212L354 510H430L565 69H567L708 510H771L603 0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "x",
    horizAdvX: 444,
    d: "M187 270L25 510H103L224 320L347 510H419L261 270L436 0H358L224 220L81 0H8L187 270Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "y",
    horizAdvX: 444,
    d: "M221 85H222L369 510H435L231 -76Q214 -131 184 -172Q169 -192 148 -203Q127 -215 100 -216Q65 -216 32 -208L38 -154Q47 -157 58 -159Q69 -162 85 -162Q124 -161 144 -130Q164 -101 177 -51L190 -6L9 510H78L221 85Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "z",
    horizAdvX: 444,
    d: "M32 53L339 456H44V510H412V456L105 54H412V0H32V53Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "{",
    horizAdvX: 278,
    d: "M273 708H223Q199 707 189 680Q179 653 179 615V450Q179 414 170 389Q160 362 146 346Q116 313 95 309V307Q105 306 119 297Q133 288 146 272Q160 256 170 229Q179 202 179 164V2Q179 -35 189 -62Q199 -91 223 -92H273V-140H217Q174 -139 146 -107Q117 -75 116 -18V152Q116 208 98 245Q79 283 38 284V332Q79 333 98 373Q116 410 116 467V635Q116 694 147 725Q175 756 218 756H273V708Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "|",
    horizAdvX: 222,
    d: "M146 750V-250H77V750H146Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "}",
    horizAdvX: 278,
    d: "M5 -92H55Q79 -91 89 -63Q99 -36 99 1V166Q99 204 110 229Q119 255 133 271Q163 303 183 307V309Q175 312 161 321Q147 330 133 346Q119 362 110 389Q99 415 99 452V614Q99 653 89 680Q79 707 55 708H5V756H61Q105 756 133 725Q161 693 162 634V464Q162 409 181 371Q200 333 240 332V284Q200 283 181 245Q162 206 162 149V-19Q161 -76 133 -108Q105 -140 60 -140H5V-92Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "~",
    horizAdvX: 600,
    d: "M531 273Q515 240 486 213Q471 200 452 192Q431 182 406 182Q379 182 350 194Q321 205 292 219Q234 253 193 255Q164 254 143 233Q123 211 105 182L69 233Q85 266 115 295Q145 323 194 324Q222 324 252 313Q281 302 308 288Q337 274 363 263Q387 251 407 251Q437 252 458 275Q479 296 495 324L531 273Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA0",
    horizAdvX: 278
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA1",
    horizAdvX: 389,
    d: "M235 426H154V510H235V426ZM166 341H223L235 -188H154L166 341Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA2",
    horizAdvX: 556,
    d: "M454 588L429 514Q461 507 474 502L469 442Q456 448 442 453Q427 458 412 461L278 59Q313 42 353 42Q412 42 468 65L474 6Q412 -13 343 -12Q298 -12 259 2L228 -91H181L218 19Q159 53 129 116Q99 179 99 255Q100 376 169 448Q237 521 351 522Q369 522 385 520L407 588H454ZM367 467Q363 468 360 468Q268 467 219 409Q168 350 168 255Q169 145 239 83L367 467Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA3",
    horizAdvX: 556,
    d: "M67 60H170V347H79V401H170V450Q170 462 172 474Q172 486 173 498Q174 510 177 522Q179 534 180 544Q186 567 195 588Q202 608 214 626Q260 703 389 705Q471 703 501 684L491 622Q478 632 452 638Q427 645 389 645Q340 645 310 628Q280 609 264 580Q250 551 244 516Q239 479 239 444V401H405V347H239V60H485V0H67V60Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA4",
    horizAdvX: 556,
    d: "M278 161Q359 162 408 218Q456 272 457 349Q456 426 408 481Q359 536 278 537Q200 532 151 479Q100 425 99 349Q100 266 151 213Q201 160 278 161ZM84 196Q30 264 30 349Q30 390 43 429Q56 468 84 500L27 555L70 600L127 544Q194 596 278 597Q365 596 430 544L484 600L529 555L475 500Q526 434 526 349Q526 263 475 196L529 141L484 98L430 154Q367 101 278 101Q191 101 127 154L70 98L27 141L84 196Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA5",
    horizAdvX: 556,
    d: "M244 175H100V223H244V298L241 304H100V352H214L19 698H95L278 361L466 698H537L343 352H457V304H316L313 298V223H457V175H313V0H244V175Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA6",
    horizAdvX: 222,
    d: "M146 175V-175H77V175H146ZM146 675V325H77V675H146Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA7",
    horizAdvX: 556,
    d: "M226 423L219 419Q204 411 182 383Q159 354 158 314Q158 288 176 268Q193 247 223 234L340 183L361 204Q398 236 399 283Q398 325 375 346Q363 358 348 366Q331 375 313 382L226 423ZM414 630Q397 640 364 648Q330 656 295 656Q255 656 212 638Q192 628 179 611Q164 595 164 571Q165 524 212 498Q256 471 314 449Q374 428 418 393Q463 358 464 295Q463 250 442 219Q420 188 389 159Q422 143 444 113Q466 83 467 41Q467 -7 445 -38Q423 -69 391 -87Q359 -105 325 -112Q290 -120 264 -120Q177 -120 95 -92L102 -33Q179 -66 264 -66Q312 -66 354 -40Q397 -15 398 39Q398 63 386 80Q372 97 351 109Q305 133 244 154Q184 175 138 211Q90 246 89 310Q89 350 114 383Q138 414 168 439L177 447L170 451Q139 469 118 496Q95 521 95 560Q97 642 157 677Q214 710 276 710Q323 710 361 703Q398 696 421 688L414 630Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA8",
    horizAdvX: 222,
    d: "M-12 730H63V646H-12V730ZM159 730H234V646H159V730Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA9",
    horizAdvX: 800,
    d: "M39 349Q41 503 146 605Q248 708 400 710Q554 708 656 605Q759 503 761 349Q759 197 656 95Q554 -10 400 -12Q248 -10 146 95Q41 197 39 349ZM591 280Q553 127 413 124Q314 125 257 190Q198 252 197 349Q197 449 254 511Q310 574 410 575Q481 575 530 537Q578 499 590 424H530Q521 469 490 495Q460 521 411 521Q340 520 304 473Q266 427 266 350Q266 279 306 230Q345 179 413 178Q462 178 492 207Q522 235 530 280H591ZM108 349Q109 217 192 131Q273 43 401 42Q528 43 609 131Q691 217 692 349Q691 483 609 568Q528 654 401 656Q273 654 192 568Q109 483 108 349Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAA",
    horizAdvX: 325,
    d: "M238 548H226Q201 548 175 547Q149 544 126 537Q76 523 75 484Q75 456 96 443Q115 430 144 430Q180 429 200 440Q219 451 228 468Q237 485 238 502Q238 519 238 530V548ZM242 444H240Q229 418 201 404Q173 388 139 388Q77 388 51 414Q23 438 24 479Q24 519 45 542Q64 565 95 575Q126 585 162 588Q197 590 230 590H238V605Q238 614 237 626Q236 637 228 646Q222 657 207 663Q192 668 167 668Q115 668 69 644V690Q89 698 116 704Q142 710 173 710Q290 709 289 596V461Q288 427 292 396H242V444Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAB",
    horizAdvX: 556,
    d: "M332 269L465 64H406L266 269L406 474H465L332 269ZM157 269L290 64H231L91 269L231 474H290L157 269Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAC",
    horizAdvX: 600,
    d: "M46 388H553V114H484V319H46V388Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAD",
    horizAdvX: 333,
    d: "M41 304H292V235H41V304Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAE",
    horizAdvX: 800,
    d: "M331 379H413Q454 378 477 392Q500 406 500 445Q499 481 474 495Q447 507 413 507H331V379ZM262 561H424Q569 561 569 442Q569 390 540 359Q511 325 460 325L580 138H507L389 325H331V138H262V561ZM108 349Q109 217 192 131Q273 43 401 42Q528 43 609 131Q691 217 692 349Q691 483 609 568Q528 654 401 656Q273 654 192 568Q109 483 108 349ZM39 349Q41 503 146 605Q248 708 400 710Q554 708 656 605Q759 503 761 349Q759 197 656 95Q554 -10 400 -12Q248 -10 146 95Q41 197 39 349Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAF",
    horizAdvX: 222,
    d: "M-11 668H233V614H-11V668Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB0",
    horizAdvX: 400,
    d: "M200 705Q267 704 312 664Q357 624 358 556Q357 489 312 449Q267 408 200 407Q135 408 90 449Q43 489 42 556Q43 624 90 664Q135 704 200 705ZM200 657Q154 657 124 631Q93 604 93 556Q94 513 126 485Q158 455 200 455Q244 455 275 485Q306 513 307 556Q306 604 277 631Q248 657 200 657Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB1",
    horizAdvX: 600,
    d: "M46 69H553V0H46V69ZM46 338H265V507H334V338H553V269H334V100H265V269H46V338Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB2",
    horizAdvX: 361,
    d: "M45 325L151 420Q194 461 225 504Q255 547 256 586Q256 621 234 639Q212 657 178 657Q120 656 69 627L61 677Q117 704 178 705Q236 705 275 679Q312 651 313 589Q312 528 274 482Q236 434 194 397L120 332H317V284H45V325Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB3",
    horizAdvX: 361,
    d: "M99 524H127Q144 524 167 527Q190 529 211 536Q233 543 248 558Q262 573 262 596Q260 637 225 648Q191 658 162 657Q105 656 59 634L55 686Q81 697 115 701Q148 705 174 705Q228 705 273 682Q295 670 307 650Q319 629 319 600Q319 563 293 537Q267 511 224 502V500Q272 497 297 469Q321 439 321 396Q319 334 267 306Q216 277 154 277Q89 276 34 294L39 346Q98 324 159 325Q201 325 232 346Q263 366 264 402Q265 430 251 446Q237 461 214 467Q166 477 127 476H99V524Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB4",
    horizAdvX: 222,
    d: "M146 716H225L99 572H53L146 716Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB5",
    horizAdvX: 556,
    d: "M79 510H142V200Q142 127 171 86Q199 42 263 42Q306 42 336 60Q366 77 382 104Q400 132 407 164Q414 196 414 228V510H477V120Q476 62 481 0H420V91H418Q411 74 399 57Q387 39 368 23Q349 8 321 -1Q293 -12 253 -12Q194 -12 142 17V-210H79V510Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB6",
    horizAdvX: 600,
    d: "M256 320Q164 321 107 375Q49 426 48 506Q52 699 276 698H516V-108H453V644H319V-108H256V320Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB7",
    horizAdvX: 278,
    d: "M92 311Q92 335 108 347Q123 359 140 359Q158 359 172 347Q186 335 187 311Q186 288 172 276Q158 264 140 264Q123 264 108 276Q92 288 92 311Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB8",
    horizAdvX: 222,
    d: "M104 0H131L112 -54Q127 -51 145 -51Q176 -51 197 -67Q217 -84 218 -116Q216 -158 181 -172Q145 -185 108 -185Q75 -184 45 -174Q15 -165 7 -163L14 -126Q25 -133 50 -143Q75 -154 103 -155Q153 -155 155 -118Q154 -81 117 -81Q96 -81 75 -85L104 0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB9",
    horizAdvX: 361,
    d: "M232 284H175V650L99 592L77 625L180 705H232V284Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBA",
    horizAdvX: 361,
    d: "M74 548Q74 496 103 464Q131 430 181 430Q233 430 260 464Q287 496 287 548Q287 598 260 632Q233 667 181 668Q131 667 103 632Q74 598 74 548ZM23 548Q23 615 61 662Q99 709 181 710Q263 708 302 663Q338 617 338 548Q338 485 302 439Q263 392 181 388Q99 390 61 437Q23 483 23 548Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBB",
    horizAdvX: 556,
    d: "M224 269L91 474H150L290 269L150 64H91L224 269ZM399 269L266 474H325L465 269L325 64H266L399 269Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBC",
    horizAdvX: 834,
    d: "M431 140L639 421H707V139H763V91H707V0H650V91H431V140ZM650 352H648L488 139H650V352ZM226 284H169V650L93 592L71 625L174 705H226V284ZM573 720H630L187 -22H130L573 720Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBD",
    horizAdvX: 834,
    d: "M503 41L609 136Q652 177 683 220Q713 263 714 302Q714 337 692 355Q670 373 636 373Q578 372 527 343L519 393Q575 420 636 421Q694 421 733 395Q770 367 771 305Q770 244 732 198Q694 150 652 113L578 48H775V0H503V41ZM214 284H157V650L81 592L59 625L162 705H214V284ZM560 720H617L174 -22H117L560 720Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBE",
    horizAdvX: 834,
    d: "M118 524H146Q163 524 186 527Q209 529 230 536Q252 543 267 558Q281 573 281 596Q279 637 244 648Q210 658 181 657Q124 656 78 634L74 686Q100 697 134 701Q167 705 193 705Q247 705 292 682Q314 670 326 650Q338 629 338 600Q338 563 312 537Q286 511 243 502V500Q291 497 316 469Q340 439 340 396Q338 334 286 306Q235 277 173 277Q108 276 53 294L58 346Q117 324 178 325Q220 325 251 346Q282 366 283 402Q284 430 270 446Q256 461 233 467Q185 477 146 476H118V524ZM450 140L658 421H726V139H782V91H726V0H669V91H450V140ZM669 352H667L507 139H669V352ZM650 720H708L265 -22H207L650 720Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBF",
    horizAdvX: 500,
    d: "M318 426H237V510H318V426ZM414 -175Q343 -199 268 -200Q189 -200 134 -156Q77 -113 76 -21Q76 41 104 82Q129 122 162 155Q196 189 221 228Q246 267 247 326V341H310V328Q309 262 285 220Q261 178 228 146Q213 130 199 113Q184 95 172 76Q146 38 145 -21Q145 -77 182 -107Q216 -139 271 -140Q312 -139 346 -131Q380 -123 411 -112L414 -175Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC0",
    horizAdvX: 667,
    d: "M181 247H484L333 632L181 247ZM299 698H377L654 0H582L507 187H155L80 0H13L299 698ZM387 738H341L215 882H294L387 738Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC1",
    horizAdvX: 667,
    d: "M181 247H484L333 632L181 247ZM299 698H377L654 0H582L507 187H155L80 0H13L299 698ZM386 882H465L339 738H293L386 882Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC2",
    horizAdvX: 667,
    d: "M181 247H484L333 632L181 247ZM299 698H377L654 0H582L507 187H155L80 0H13L299 698ZM299 882H381L474 738H428L340 840L252 738H206L299 882Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC3",
    horizAdvX: 667,
    d: "M181 247H484L333 632L181 247ZM299 698H377L654 0H582L507 187H155L80 0H13L299 698ZM204 755Q212 790 231 817Q251 844 285 845Q316 844 346 833Q376 821 390 820Q407 820 421 829Q434 838 439 854H476Q467 801 441 783Q414 765 393 766Q358 767 331 779Q304 790 284 791Q265 791 257 782Q247 773 240 755H204Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC4",
    horizAdvX: 667,
    d: "M181 247H484L333 632L181 247ZM299 698H377L654 0H582L507 187H155L80 0H13L299 698ZM217 842H292V758H217V842ZM388 842H463V758H388V842Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC5",
    horizAdvX: 667,
    d: "M181 247H484L333 632L181 247ZM299 698H377L654 0H582L507 187H155L80 0H13L299 698ZM281 816Q281 790 299 775Q316 757 341 757Q367 757 384 775Q401 790 401 816Q401 842 384 859Q367 875 341 875Q316 875 299 859Q281 842 281 816ZM245 816Q245 858 273 884Q300 910 341 911Q382 910 410 884Q436 858 437 816Q436 775 410 749Q382 721 341 721Q300 721 273 749Q245 775 245 816Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC6",
    horizAdvX: 889,
    d: "M436 698H817V638H546V389H803V329H546V60H829V0H478V187H192L76 0H0L436 698ZM477 644H475L229 247H477V644Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC7",
    horizAdvX: 667,
    d: "M565 620Q531 638 490 645Q447 650 409 650Q273 648 200 565Q126 482 126 349Q126 215 199 133Q271 49 409 48Q445 48 490 55Q534 61 565 78L569 18Q538 2 492 -5Q445 -12 409 -12Q401 -12 395 -11L380 -54Q395 -51 413 -51Q444 -51 465 -67Q485 -84 486 -116Q484 -158 449 -172Q413 -185 376 -185Q343 -184 313 -174Q283 -165 275 -163L282 -126Q293 -133 318 -143Q343 -154 371 -155Q421 -155 423 -118Q422 -81 385 -81Q364 -81 343 -85L368 -9Q220 5 140 101Q57 196 57 349Q58 511 152 610Q245 708 409 710Q443 710 492 705Q540 699 569 684L565 620H565Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC8",
    horizAdvX: 500,
    d: "M86 698H428V638H155V389H414V329H155V60H440V0H86V698ZM299 738H253L127 882H206L299 738Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC9",
    horizAdvX: 500,
    d: "M86 698H428V638H155V389H414V329H155V60H440V0H86V698ZM297 882H376L250 738H204L297 882Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCA",
    horizAdvX: 500,
    d: "M86 698H428V638H155V389H414V329H155V60H440V0H86V698ZM209 882H291L384 738H338L250 840L162 738H116L209 882Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCB",
    horizAdvX: 500,
    d: "M86 698H428V638H155V389H414V329H155V60H440V0H86V698ZM129 842H204V758H129V842ZM300 842H375V758H300V842Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCC",
    horizAdvX: 222,
    d: "M77 698H146V0H77V698ZM160 738H114L-12 882H67L160 738Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCD",
    horizAdvX: 222,
    d: "M77 698H146V0H77V698ZM155 882H234L108 738H62L155 882Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCE",
    horizAdvX: 222,
    d: "M77 698H146V0H77V698ZM68 882H150L243 738H197L109 840L21 738H-25L68 882Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCF",
    horizAdvX: 222,
    d: "M77 698H146V0H77V698ZM-12 842H63V758H-12V842ZM159 842H234V758H159V842Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD0",
    horizAdvX: 667,
    d: "M149 389H362V329H149V60H206Q525 53 533 354Q532 519 441 580Q350 639 195 638H149V389ZM80 698H198Q595 704 602 350Q600 163 489 81Q379 0 202 0H80V329H11V389H80V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD1",
    horizAdvX: 667,
    d: "M77 698H164L519 84H521V698H590V0H497L148 602H146V0H77V698ZM203 755Q211 790 230 817Q250 844 284 845Q315 844 345 833Q375 821 389 820Q406 820 420 829Q433 838 438 854H475Q466 801 440 783Q413 765 392 766Q357 767 330 779Q303 790 283 791Q264 791 256 782Q246 773 239 755H203Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD2",
    horizAdvX: 722,
    d: "M361 650Q239 647 181 556Q123 465 123 349Q123 233 181 144Q239 50 361 48Q484 50 542 144Q599 233 599 349Q599 465 542 556Q484 647 361 650ZM54 349Q53 496 129 601Q204 707 361 710Q519 707 595 601Q670 496 668 349Q667 186 590 89Q512 -10 361 -12Q211 -10 134 89Q56 186 54 349ZM415 738H369L243 882H322L415 738Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD3",
    horizAdvX: 722,
    d: "M361 650Q239 647 181 556Q123 465 123 349Q123 233 181 144Q239 50 361 48Q484 50 542 144Q599 233 599 349Q599 465 542 556Q484 647 361 650ZM54 349Q53 496 129 601Q204 707 361 710Q519 707 595 601Q670 496 668 349Q667 186 590 89Q512 -10 361 -12Q211 -10 134 89Q56 186 54 349ZM412 882H491L365 738H319L412 882Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD4",
    horizAdvX: 722,
    d: "M361 650Q239 647 181 556Q123 465 123 349Q123 233 181 144Q239 50 361 48Q484 50 542 144Q599 233 599 349Q599 465 542 556Q484 647 361 650ZM54 349Q53 496 129 601Q204 707 361 710Q519 707 595 601Q670 496 668 349Q667 186 590 89Q512 -10 361 -12Q211 -10 134 89Q56 186 54 349ZM323 882H405L498 738H452L364 840L276 738H230L323 882Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD5",
    horizAdvX: 722,
    d: "M361 650Q239 647 181 556Q123 465 123 349Q123 233 181 144Q239 50 361 48Q484 50 542 144Q599 233 599 349Q599 465 542 556Q484 647 361 650ZM54 349Q53 496 129 601Q204 707 361 710Q519 707 595 601Q670 496 668 349Q667 186 590 89Q512 -10 361 -12Q211 -10 134 89Q56 186 54 349ZM230 755Q238 790 257 817Q277 844 311 845Q342 844 372 833Q402 821 416 820Q433 820 447 829Q460 838 465 854H502Q493 801 467 783Q440 765 419 766Q384 767 357 779Q330 790 310 791Q291 791 283 782Q273 773 266 755H230Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD6",
    horizAdvX: 722,
    d: "M361 650Q239 647 181 556Q123 465 123 349Q123 233 181 144Q239 50 361 48Q484 50 542 144Q599 233 599 349Q599 465 542 556Q484 647 361 650ZM54 349Q53 496 129 601Q204 707 361 710Q519 707 595 601Q670 496 668 349Q667 186 590 89Q512 -10 361 -12Q211 -10 134 89Q56 186 54 349ZM243 842H318V758H243V842ZM414 842H489V758H414V842Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD7",
    horizAdvX: 600,
    d: "M71 437L120 486L301 305L480 486L530 437L350 257L530 76L480 26L301 208L120 26L71 76L252 257L71 437Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD8",
    horizAdvX: 722,
    d: "M693 694L602 589Q670 489 668 349Q667 186 590 89Q512 -10 361 -12Q224 -11 149 71L68 -22L29 11L117 112Q56 204 54 349Q53 496 129 601Q204 707 361 710Q493 709 568 629L654 727L693 694ZM196 124Q253 50 361 48Q484 50 542 144Q599 233 599 349Q599 450 554 534L196 124ZM523 577Q465 648 361 650Q239 647 181 556Q123 465 123 349Q123 250 166 169L523 577Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD9",
    horizAdvX: 667,
    d: "M587 244Q586 168 563 118Q538 67 500 39Q461 11 418 0Q374 -12 334 -12Q296 -12 253 0Q209 11 170 39Q132 67 107 118Q81 168 81 244V698H150V244Q150 157 197 104Q244 49 334 48Q426 49 472 104Q518 157 518 244V698H587V244ZM387 738H341L215 882H294L387 738Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDA",
    horizAdvX: 667,
    d: "M587 244Q586 168 563 118Q538 67 500 39Q461 11 418 0Q374 -12 334 -12Q296 -12 253 0Q209 11 170 39Q132 67 107 118Q81 168 81 244V698H150V244Q150 157 197 104Q244 49 334 48Q426 49 472 104Q518 157 518 244V698H587V244ZM383 882H462L336 738H290L383 882Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDB",
    horizAdvX: 667,
    d: "M587 244Q586 168 563 118Q538 67 500 39Q461 11 418 0Q374 -12 334 -12Q296 -12 253 0Q209 11 170 39Q132 67 107 118Q81 168 81 244V698H150V244Q150 157 197 104Q244 49 334 48Q426 49 472 104Q518 157 518 244V698H587V244ZM296 882H378L471 738H425L337 840L249 738H203L296 882Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDC",
    horizAdvX: 667,
    d: "M587 244Q586 168 563 118Q538 67 500 39Q461 11 418 0Q374 -12 334 -12Q296 -12 253 0Q209 11 170 39Q132 67 107 118Q81 168 81 244V698H150V244Q150 157 197 104Q244 49 334 48Q426 49 472 104Q518 157 518 244V698H587V244ZM215 842H290V758H215V842ZM386 842H461V758H386V842Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDD",
    horizAdvX: 611,
    d: "M271 296L12 698H92L305 357L524 698H599L340 296V0H271V296ZM357 882H436L310 738H264L357 882Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDE",
    horizAdvX: 500,
    d: "M155 232H203Q243 232 279 237Q315 241 344 254Q373 268 389 296Q405 324 405 370Q403 506 267 508H155V232ZM86 698H155V568H258Q469 568 474 370Q473 273 410 223Q348 172 251 172H155V0H86V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDF",
    horizAdvX: 556,
    d: "M79 542Q79 641 128 701Q177 761 279 762Q463 758 468 576Q466 435 334 402V400Q505 380 506 215Q505 117 449 57Q392 -6 289 -7Q273 -7 250 -4Q226 -2 204 5L208 64Q244 46 290 47Q362 48 400 95Q437 140 437 214Q436 301 385 335Q334 367 246 367H236V421H254Q319 421 359 463Q398 504 399 574Q399 633 368 670Q336 707 279 708Q252 708 228 701Q204 692 184 671Q166 650 155 614Q142 577 142 520V0H79V542Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE0",
    horizAdvX: 500,
    d: "M366 257H348Q307 257 266 255Q223 251 188 238Q153 226 132 201Q109 176 109 134Q109 85 141 64Q171 42 215 42Q270 42 302 64Q333 85 347 114Q362 145 364 175Q366 206 366 226V257ZM372 82H370Q348 37 303 13Q258 -11 208 -12Q155 -11 122 5Q88 20 70 43Q38 93 40 132Q40 196 71 233Q101 270 148 286Q195 303 250 308Q304 311 354 311H366V337Q369 468 250 468Q171 469 100 426V487Q171 520 250 522Q431 524 429 332V107Q428 49 434 0H372V82ZM309 567H263L137 711H216L309 567Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE1",
    horizAdvX: 500,
    d: "M366 257H348Q307 257 266 255Q223 251 188 238Q153 226 132 201Q109 176 109 134Q109 85 141 64Q171 42 215 42Q270 42 302 64Q333 85 347 114Q362 145 364 175Q366 206 366 226V257ZM372 82H370Q348 37 303 13Q258 -11 208 -12Q155 -11 122 5Q88 20 70 43Q38 93 40 132Q40 196 71 233Q101 270 148 286Q195 303 250 308Q304 311 354 311H366V337Q369 468 250 468Q171 469 100 426V487Q171 520 250 522Q431 524 429 332V107Q428 49 434 0H372V82ZM287 711H366L240 567H194L287 711Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE2",
    horizAdvX: 500,
    d: "M366 257H348Q307 257 266 255Q223 251 188 238Q153 226 132 201Q109 176 109 134Q109 85 141 64Q171 42 215 42Q270 42 302 64Q333 85 347 114Q362 145 364 175Q366 206 366 226V257ZM372 82H370Q348 37 303 13Q258 -11 208 -12Q155 -11 122 5Q88 20 70 43Q38 93 40 132Q40 196 71 233Q101 270 148 286Q195 303 250 308Q304 311 354 311H366V337Q369 468 250 468Q171 469 100 426V487Q171 520 250 522Q431 524 429 332V107Q428 49 434 0H372V82ZM210 711H292L385 567H339L251 669L163 567H117L210 711Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE3",
    horizAdvX: 500,
    d: "M366 257H348Q307 257 266 255Q223 251 188 238Q153 226 132 201Q109 176 109 134Q109 85 141 64Q171 42 215 42Q270 42 302 64Q333 85 347 114Q362 145 364 175Q366 206 366 226V257ZM372 82H370Q348 37 303 13Q258 -11 208 -12Q155 -11 122 5Q88 20 70 43Q38 93 40 132Q40 196 71 233Q101 270 148 286Q195 303 250 308Q304 311 354 311H366V337Q369 468 250 468Q171 469 100 426V487Q171 520 250 522Q431 524 429 332V107Q428 49 434 0H372V82ZM112 590Q120 625 139 652Q159 679 193 680Q224 679 254 668Q284 656 298 655Q315 655 329 664Q342 673 347 689H384Q375 636 349 618Q322 600 301 601Q266 602 239 614Q212 625 192 626Q173 626 165 617Q155 608 148 590H112Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE4",
    horizAdvX: 500,
    d: "M366 257H348Q307 257 266 255Q223 251 188 238Q153 226 132 201Q109 176 109 134Q109 85 141 64Q171 42 215 42Q270 42 302 64Q333 85 347 114Q362 145 364 175Q366 206 366 226V257ZM372 82H370Q348 37 303 13Q258 -11 208 -12Q155 -11 122 5Q88 20 70 43Q38 93 40 132Q40 196 71 233Q101 270 148 286Q195 303 250 308Q304 311 354 311H366V337Q369 468 250 468Q171 469 100 426V487Q171 520 250 522Q431 524 429 332V107Q428 49 434 0H372V82ZM128 725H203V641H128V725ZM299 725H374V641H299V725Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE5",
    horizAdvX: 500,
    d: "M366 257H348Q307 257 266 255Q223 251 188 238Q153 226 132 201Q109 176 109 134Q109 85 141 64Q171 42 215 42Q270 42 302 64Q333 85 347 114Q362 145 364 175Q366 206 366 226V257ZM372 82H370Q348 37 303 13Q258 -11 208 -12Q155 -11 122 5Q88 20 70 43Q38 93 40 132Q40 196 71 233Q101 270 148 286Q195 303 250 308Q304 311 354 311H366V337Q369 468 250 468Q171 469 100 426V487Q171 520 250 522Q431 524 429 332V107Q428 49 434 0H372V82ZM191 648Q191 622 209 607Q226 589 251 589Q277 589 294 607Q311 622 311 648Q311 674 294 691Q277 707 251 707Q226 707 209 691Q191 674 191 648ZM155 648Q155 690 183 716Q210 742 251 743Q292 742 320 716Q346 690 347 648Q346 607 320 581Q292 553 251 553Q210 553 183 581Q155 607 155 648Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE6",
    horizAdvX: 833,
    d: "M718 291Q718 361 689 413Q658 466 588 468Q521 466 482 413Q441 360 441 291H718ZM749 16Q677 -11 601 -12Q444 -8 407 91Q364 31 314 9Q264 -12 214 -12Q138 -12 93 23Q46 56 46 124Q46 185 77 219Q105 253 150 269Q195 285 242 289Q290 291 328 291H372V318Q373 384 350 426Q338 446 316 457Q293 468 257 468Q176 469 106 426V487Q177 520 256 522Q313 522 354 503Q395 483 419 430Q447 473 491 497Q534 522 584 522Q691 520 740 447Q787 375 787 269V237H441V214Q440 140 480 92Q518 43 606 42Q643 42 684 55Q725 66 749 80V16ZM372 237H350Q321 237 281 236Q241 233 203 223Q166 213 141 190Q115 167 115 124Q116 84 150 63Q182 42 221 42Q304 43 339 92Q373 139 372 210V237Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE7",
    horizAdvX: 444,
    d: "M411 442Q357 467 302 468Q210 467 161 409Q110 350 110 255Q110 166 160 106Q209 43 295 42Q354 42 410 65L416 6Q354 -13 285 -12H283L268 -54Q283 -51 301 -51Q332 -51 353 -67Q373 -84 374 -116Q372 -158 337 -172Q301 -185 264 -185Q231 -184 201 -174Q171 -165 163 -163L170 -126Q181 -133 206 -143Q231 -154 259 -155Q309 -155 311 -118Q310 -81 273 -81Q252 -81 231 -85L257 -10Q148 3 95 78Q41 153 41 255Q42 376 111 448Q179 521 293 522Q340 522 371 515Q387 512 399 509Q410 505 416 502L411 442Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE8",
    horizAdvX: 500,
    d: "M390 291Q390 361 361 413Q330 466 260 468Q191 466 151 412Q110 358 110 291H390ZM421 16Q349 -11 273 -12Q148 -10 94 65Q40 138 41 255Q42 374 101 448Q158 521 256 522Q363 520 412 447Q459 375 459 269V237H110Q110 154 153 100Q195 43 278 42Q315 42 356 55Q397 66 421 80V16ZM308 567H262L136 711H215L308 567Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE9",
    horizAdvX: 500,
    d: "M390 291Q390 361 361 413Q330 466 260 468Q191 466 151 412Q110 358 110 291H390ZM421 16Q349 -11 273 -12Q148 -10 94 65Q40 138 41 255Q42 374 101 448Q158 521 256 522Q363 520 412 447Q459 375 459 269V237H110Q110 154 153 100Q195 43 278 42Q315 42 356 55Q397 66 421 80V16ZM288 711H367L241 567H195L288 711Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEA",
    horizAdvX: 500,
    d: "M390 291Q390 361 361 413Q330 466 260 468Q191 466 151 412Q110 358 110 291H390ZM421 16Q349 -11 273 -12Q148 -10 94 65Q40 138 41 255Q42 374 101 448Q158 521 256 522Q363 520 412 447Q459 375 459 269V237H110Q110 154 153 100Q195 43 278 42Q315 42 356 55Q397 66 421 80V16ZM211 711H293L386 567H340L252 669L164 567H118L211 711Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEB",
    horizAdvX: 500,
    d: "M390 291Q390 361 361 413Q330 466 260 468Q191 466 151 412Q110 358 110 291H390ZM421 16Q349 -11 273 -12Q148 -10 94 65Q40 138 41 255Q42 374 101 448Q158 521 256 522Q363 520 412 447Q459 375 459 269V237H110Q110 154 153 100Q195 43 278 42Q315 42 356 55Q397 66 421 80V16ZM129 725H204V641H129V725ZM300 725H375V641H300V725Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEC",
    horizAdvX: 222,
    d: "M168 567H122L-4 711H75L168 567ZM79 510H142V0H79V510Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xED",
    horizAdvX: 222,
    d: "M146 711H225L99 567H53L146 711ZM79 510H142V0H79V510Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEE",
    horizAdvX: 222,
    d: "M70 711H152L245 567H199L111 669L23 567H-23L70 711ZM79 510H142V0H79V510Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEF",
    horizAdvX: 222,
    d: "M79 510H142V0H79V510ZM-12 725H63V641H-12V725ZM159 725H234V641H159V725Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF0",
    horizAdvX: 556,
    d: "M182 606L273 663Q212 699 138 714L150 762Q259 746 332 699L439 765L469 723L376 666Q518 532 516 296Q517 -9 278 -12Q156 -10 98 70Q40 148 40 255Q40 364 98 441Q156 520 278 522Q374 521 435 443H437Q408 561 320 631L212 564L182 606ZM109 255Q109 164 153 105Q195 43 278 42Q361 43 405 105Q447 164 447 255Q447 346 405 407Q361 467 278 468Q195 467 153 407Q109 346 109 255Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF1",
    horizAdvX: 556,
    d: "M79 390Q79 449 75 510H136V419H138Q147 437 159 455Q171 473 189 488Q208 504 236 513Q264 522 303 522Q397 521 438 466Q477 412 477 326V0H414V310Q414 383 387 426Q358 467 293 468Q209 466 175 408Q157 381 150 349Q142 316 142 282V0H79V390ZM142 590Q150 625 169 652Q189 679 223 680Q254 679 284 668Q314 656 328 655Q345 655 359 664Q372 673 377 689H414Q405 636 379 618Q352 600 331 601Q296 602 269 614Q242 625 222 626Q203 626 195 617Q185 608 178 590H142Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF2",
    horizAdvX: 556,
    d: "M109 255Q109 164 153 105Q195 43 278 42Q361 43 405 105Q447 164 447 255Q447 346 405 407Q361 467 278 468Q195 467 153 407Q109 346 109 255ZM40 255Q40 364 98 441Q156 520 278 522Q402 520 460 441Q516 364 516 255Q516 148 460 70Q402 -10 278 -12Q156 -10 98 70Q40 148 40 255ZM339 567H293L167 711H246L339 567Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF3",
    horizAdvX: 556,
    d: "M109 255Q109 164 153 105Q195 43 278 42Q361 43 405 105Q447 164 447 255Q447 346 405 407Q361 467 278 468Q195 467 153 407Q109 346 109 255ZM40 255Q40 364 98 441Q156 520 278 522Q402 520 460 441Q516 364 516 255Q516 148 460 70Q402 -10 278 -12Q156 -10 98 70Q40 148 40 255ZM319 711H398L272 567H226L319 711Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF4",
    horizAdvX: 556,
    d: "M109 255Q109 164 153 105Q195 43 278 42Q361 43 405 105Q447 164 447 255Q447 346 405 407Q361 467 278 468Q195 467 153 407Q109 346 109 255ZM40 255Q40 364 98 441Q156 520 278 522Q402 520 460 441Q516 364 516 255Q516 148 460 70Q402 -10 278 -12Q156 -10 98 70Q40 148 40 255ZM240 711H322L415 567H369L281 669L193 567H147L240 711Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF5",
    horizAdvX: 556,
    d: "M109 255Q109 164 153 105Q195 43 278 42Q361 43 405 105Q447 164 447 255Q447 346 405 407Q361 467 278 468Q195 467 153 407Q109 346 109 255ZM40 255Q40 364 98 441Q156 520 278 522Q402 520 460 441Q516 364 516 255Q516 148 460 70Q402 -10 278 -12Q156 -10 98 70Q40 148 40 255ZM143 590Q151 625 170 652Q190 679 224 680Q255 679 285 668Q315 656 329 655Q346 655 360 664Q373 673 378 689H415Q406 636 380 618Q353 600 332 601Q297 602 270 614Q243 625 223 626Q204 626 196 617Q186 608 179 590H143Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF6",
    horizAdvX: 556,
    d: "M109 255Q109 164 153 105Q195 43 278 42Q361 43 405 105Q447 164 447 255Q447 346 405 407Q361 467 278 468Q195 467 153 407Q109 346 109 255ZM40 255Q40 364 98 441Q156 520 278 522Q402 520 460 441Q516 364 516 255Q516 148 460 70Q402 -10 278 -12Q156 -10 98 70Q40 148 40 255ZM159 725H234V641H159V725ZM330 725H405V641H330V725Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF7",
    horizAdvX: 600,
    d: "M236 57Q236 85 256 103Q274 120 300 121Q326 121 345 102Q364 83 364 57Q364 32 345 13Q326 -6 300 -7Q274 -6 256 13Q236 31 236 57ZM236 450Q236 478 256 496Q274 513 300 514Q326 514 345 495Q364 476 364 450Q364 425 345 406Q326 386 300 386Q274 386 256 406Q236 424 236 450ZM46 288H553V219H46V288Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF8",
    horizAdvX: 556,
    d: "M537 516L464 432Q516 358 516 255Q516 148 460 70Q402 -10 278 -12Q181 -11 124 41L54 -40L19 -11L94 75Q39 152 40 255Q40 364 98 441Q156 520 278 522Q380 521 434 466L502 545L537 516ZM166 89Q209 42 278 42Q361 43 405 105Q447 164 447 255Q447 327 419 380L166 89ZM393 419Q349 467 278 468Q195 467 153 407Q109 346 109 255Q109 182 139 127L393 419Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF9",
    horizAdvX: 556,
    d: "M477 120Q476 62 481 0H420V91H418Q411 74 399 57Q387 39 368 23Q349 8 321 -1Q293 -12 253 -12Q160 -11 119 44Q78 98 79 184V510H142V200Q142 127 171 86Q199 42 263 42Q306 42 336 60Q366 77 382 104Q400 132 407 164Q414 196 414 228V510H477V120ZM336 567H290L164 711H243L336 567Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFA",
    horizAdvX: 556,
    d: "M477 120Q476 62 481 0H420V91H418Q411 74 399 57Q387 39 368 23Q349 8 321 -1Q293 -12 253 -12Q160 -11 119 44Q78 98 79 184V510H142V200Q142 127 171 86Q199 42 263 42Q306 42 336 60Q366 77 382 104Q400 132 407 164Q414 196 414 228V510H477V120ZM316 711H395L269 567H223L316 711Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFB",
    horizAdvX: 556,
    d: "M477 120Q476 62 481 0H420V91H418Q411 74 399 57Q387 39 368 23Q349 8 321 -1Q293 -12 253 -12Q160 -11 119 44Q78 98 79 184V510H142V200Q142 127 171 86Q199 42 263 42Q306 42 336 60Q366 77 382 104Q400 132 407 164Q414 196 414 228V510H477V120ZM238 711H320L413 567H367L279 669L191 567H145L238 711Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFC",
    horizAdvX: 556,
    d: "M477 120Q476 62 481 0H420V91H418Q411 74 399 57Q387 39 368 23Q349 8 321 -1Q293 -12 253 -12Q160 -11 119 44Q78 98 79 184V510H142V200Q142 127 171 86Q199 42 263 42Q306 42 336 60Q366 77 382 104Q400 132 407 164Q414 196 414 228V510H477V120ZM157 725H232V641H157V725ZM328 725H403V641H328V725Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFD",
    horizAdvX: 444,
    d: "M221 85H222L369 510H435L231 -76Q214 -131 184 -172Q169 -192 148 -203Q127 -215 100 -216Q65 -216 32 -208L38 -154Q47 -157 58 -159Q69 -162 85 -162Q124 -161 144 -130Q164 -101 177 -51L190 -6L9 510H78L221 85ZM261 711H340L214 567H168L261 711Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFE",
    horizAdvX: 556,
    d: "M438 255Q438 293 433 331Q426 369 408 399Q392 431 362 449Q332 468 287 468Q245 468 217 449Q188 429 170 397Q152 365 145 329Q136 291 136 255Q135 182 170 114Q188 82 217 63Q245 42 287 42Q332 42 362 63Q392 82 408 112Q426 144 433 182Q438 219 438 255ZM73 750H136V417H138Q142 428 154 447Q164 464 182 481Q201 498 229 511Q257 522 297 522Q409 521 459 447Q507 374 507 255Q507 140 455 65Q402 -10 297 -12Q181 -12 138 93H136V-210H73V750Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFF",
    horizAdvX: 444,
    d: "M221 85H222L369 510H435L231 -76Q214 -131 184 -172Q169 -192 148 -203Q127 -215 100 -216Q65 -216 32 -208L38 -154Q47 -157 58 -159Q69 -162 85 -162Q124 -161 144 -130Q164 -101 177 -51L190 -6L9 510H78L221 85ZM101 725H176V641H101V725ZM272 725H347V641H272V725Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0131",
    horizAdvX: 222,
    d: "M79 510H142V0H79V510Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0152",
    horizAdvX: 889,
    d: "M477 638Q425 643 350 644Q337 644 301 640Q285 637 265 630Q245 621 225 608Q185 582 155 521Q141 490 133 448Q123 405 123 349Q124 241 155 180Q170 149 188 128Q206 106 225 91Q265 65 301 59Q337 53 350 54Q425 54 477 60V638ZM817 638H546V389H803V329H546V60H829V0H499Q415 -2 331 -7Q184 -4 119 106Q53 213 54 349Q53 487 119 593Q184 702 331 705Q415 702 499 698H817V638Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0153",
    horizAdvX: 889,
    d: "M105 255Q105 164 149 105Q191 43 274 42Q322 42 353 60Q384 77 402 106Q435 166 434 255Q435 340 402 403Q384 433 353 451Q322 468 274 468Q191 467 149 407Q105 346 105 255ZM503 237Q503 154 546 100Q588 43 671 42Q708 42 749 55Q790 66 814 80V16Q742 -11 666 -12Q519 -10 470 92Q416 -9 274 -12Q152 -10 94 70Q36 148 36 255Q36 364 94 441Q152 520 274 522Q408 524 466 412Q521 521 649 522Q756 520 805 446Q852 372 852 271V237H503ZM783 291Q783 361 752 413Q719 466 653 468Q581 467 543 419Q503 371 503 291H783Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0160",
    horizAdvX: 500,
    d: "M67 89Q126 48 221 48Q288 48 333 83Q377 118 378 191Q377 242 328 277Q306 295 277 311Q248 327 218 343Q188 360 160 379Q131 397 108 419Q59 462 58 528Q59 613 123 662Q185 709 279 710Q306 710 343 706Q380 700 416 687L405 624Q354 650 278 650Q251 650 225 645Q199 639 176 624Q155 611 141 588Q127 564 127 530Q127 505 141 484Q155 463 177 447Q200 430 229 415Q257 399 287 382Q350 352 397 306Q420 284 434 254Q447 224 447 185Q445 81 374 34Q304 -12 218 -12Q116 -10 60 18L67 89ZM293 738H211L118 882H164L252 780L340 882H386L293 738Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0161",
    horizAdvX: 389,
    d: "M40 74Q98 43 173 42Q220 42 253 67Q285 90 286 133Q285 178 249 204Q213 229 164 249Q141 260 120 272Q99 284 80 299Q63 315 52 336Q41 356 41 383Q42 459 93 491Q142 522 207 522Q229 522 264 518Q299 512 333 499L327 444Q272 467 214 468Q165 468 136 450Q121 441 113 425Q104 409 104 383Q104 367 115 353Q126 340 144 329Q162 319 185 308Q208 298 230 286Q280 265 317 230Q354 195 355 133Q355 93 339 66Q322 38 296 21Q240 -12 177 -12Q103 -12 34 12L40 74H40ZM236 567H154L61 711H107L195 609L283 711H329L236 567Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0178",
    horizAdvX: 611,
    d: "M271 296L12 698H92L305 357L524 698H599L340 296V0H271V296ZM189 842H264V758H189V842ZM360 842H435V758H360V842Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u017D",
    horizAdvX: 500,
    d: "M21 60L385 638H30V698H458V638L96 60H470V0H21V60ZM292 738H210L117 882H163L251 780L339 882H385L292 738Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u017E",
    horizAdvX: 444,
    d: "M32 53L339 456H44V510H412V456L105 54H412V0H32V53ZM263 572H181L88 716H134L222 614L310 716H356L263 572Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0192",
    horizAdvX: 556,
    d: "M458 365H332L261 2Q241 -110 203 -163Q165 -216 83 -216Q49 -215 25 -206L41 -153Q62 -161 84 -162Q139 -161 163 -112Q187 -64 199 13L266 365H155V419H277L294 510Q301 548 313 583Q324 618 343 645Q363 672 394 689Q424 705 469 705Q503 704 533 688L520 638Q494 650 464 651Q446 651 431 646Q416 639 404 623Q379 593 361 511L343 419H458V365Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02C6",
    horizAdvX: 222,
    d: "M70 716H152L245 572H199L111 674L23 572H-23L70 716Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02C7",
    horizAdvX: 222,
    d: "M152 572H70L-23 716H23L111 614L199 716H245L152 572Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02DA",
    horizAdvX: 222,
    d: "M51 648Q51 622 69 607Q86 589 111 589Q137 589 154 607Q171 622 171 648Q171 674 154 691Q137 707 111 707Q86 707 69 691Q51 674 51 648ZM15 648Q15 690 43 716Q70 742 111 743Q152 742 180 716Q206 690 207 648Q206 607 180 581Q152 553 111 553Q70 553 43 581Q15 607 15 648Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02DC",
    horizAdvX: 222,
    d: "M-27 595Q-19 630 0 657Q20 684 54 685Q85 684 115 673Q145 661 159 660Q176 660 190 669Q203 678 208 694H245Q236 641 210 623Q183 605 162 606Q127 607 100 619Q73 630 53 631Q34 631 26 622Q16 613 9 595H-27Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2013",
    horizAdvX: 500,
    d: "M0 296H500V242H0V296Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2014",
    horizAdvX: 1000,
    d: "M0 296H1000V242H0V296Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2018",
    horizAdvX: 278,
    d: "M147 480H72L149 698H206L147 480Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2019",
    horizAdvX: 278,
    d: "M131 698H206L129 480H72L131 698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201A",
    horizAdvX: 278,
    d: "M131 84H206L129 -134H72L131 84Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201C",
    horizAdvX: 556,
    d: "M374 480H299L376 698H433L374 480ZM198 480H123L200 698H257L198 480Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201D",
    horizAdvX: 556,
    d: "M182 698H257L180 480H123L182 698ZM358 698H433L356 480H299L358 698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201E",
    horizAdvX: 556,
    d: "M358 84H433L356 -134H299L358 84ZM182 84H257L181 -134H123L182 84Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2020",
    horizAdvX: 556,
    d: "M246 456H71V510H246V698H309V510H485V456H309V0H246V456Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2021",
    horizAdvX: 556,
    d: "M71 242H246V456H71V510H246V698H309V510H485V456H309V242H485V188H309V0H246V188H71V242Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2022",
    horizAdvX: 500,
    d: "M76 349Q77 423 128 473Q176 523 250 524Q324 523 374 473Q424 423 425 349Q424 275 374 227Q324 176 250 175Q176 176 128 227Q77 275 76 349Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2026",
    horizAdvX: 1000,
    d: "M793 84H874V0H793V84ZM460 84H541V0H460V84ZM127 84H208V0H127V84Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2030",
    horizAdvX: 1000,
    d: "M521 720H579L166 -22H108L521 720ZM757 170Q757 152 759 130Q760 107 766 87Q773 67 788 55Q801 41 826 41Q853 41 867 55Q882 67 887 87Q896 129 895 170Q895 190 894 213Q893 234 887 254Q882 274 867 287Q853 299 826 299Q801 299 788 287Q773 274 766 254Q756 211 757 170ZM694 170Q694 203 700 235Q705 265 718 291Q733 317 759 332Q784 347 826 347Q868 347 895 332Q921 317 934 291Q949 265 954 235Q958 203 958 170Q958 138 954 108Q949 76 934 50Q921 24 895 9Q868 -6 826 -7Q784 -6 759 9Q733 24 718 50Q705 76 700 108Q694 138 694 170ZM443 170Q443 152 445 130Q446 107 452 87Q459 67 474 55Q487 41 512 41Q539 41 553 55Q568 67 573 87Q582 129 581 170Q581 190 580 213Q579 234 573 254Q568 274 553 287Q539 299 512 299Q487 299 474 287Q459 274 452 254Q442 211 443 170ZM380 170Q380 203 386 235Q391 265 404 291Q419 317 445 332Q470 347 512 347Q554 347 581 332Q607 317 620 291Q635 265 640 235Q644 203 644 170Q644 138 640 108Q635 76 620 50Q607 24 581 9Q554 -6 512 -7Q470 -6 445 9Q419 24 404 50Q391 76 386 108Q380 138 380 170ZM105 528Q105 510 107 488Q108 465 114 445Q121 425 136 413Q149 399 174 399Q201 399 215 413Q230 425 235 445Q244 487 243 528Q243 548 242 571Q241 592 235 612Q230 632 215 645Q201 657 174 657Q149 657 136 645Q121 632 114 612Q104 569 105 528ZM42 528Q42 564 49 597Q55 629 69 653Q96 704 174 705Q253 704 281 653Q307 601 306 528Q307 455 281 405Q266 381 241 367Q214 351 174 351Q96 352 69 405Q55 431 49 462Q42 494 42 528Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2039",
    horizAdvX: 278,
    d: "M105 269L238 64H179L39 269L179 474H238L105 269Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u203A",
    horizAdvX: 278,
    d: "M173 269L40 474H99L239 269L99 64H40L173 269Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u20AC",
    horizAdvX: 556,
    d: "M566 685L553 622Q503 651 423 651Q327 651 263 594T176 442H517L506 394H167Q162 350 167 304H488L478 256H176Q198 160 262 104T422 48Q499 48 553 75L559 11Q507 -12 422 -12Q296 -12 212 59T104 256H14L25 304H98Q94 350 98 394H14L25 442H105Q130 565 215 637T424 710Q509 710 566 685Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2122",
    horizAdvX: 990,
    d: "M478 698H580L702 379L824 698H926V284H863V644H861L723 284H680L543 644H541V284H478V698ZM195 650H64V698H389V650H258V284H195V650Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uE300",
    horizAdvX: 222,
    d: "M167 738H121L-5 882H74L167 738Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uE301",
    horizAdvX: 222,
    d: "M146 882H225L99 738H53L146 882Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uE302",
    horizAdvX: 222,
    d: "M68 882H150L243 738H197L109 840L21 738H-25L68 882Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uE303",
    horizAdvX: 222,
    d: "M150 738H68L-25 882H21L109 780L197 882H243L150 738Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uE304",
    horizAdvX: 222,
    d: "M-29 755Q-21 790 -2 817Q18 844 52 845Q83 844 113 833Q143 821 157 820Q174 820 188 829Q201 838 206 854H243Q234 801 208 783Q181 765 160 766Q125 767 98 779Q71 790 51 791Q32 791 24 782Q14 773 7 755H-29Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uE305",
    horizAdvX: 222,
    d: "M-12 842H63V758H-12V842ZM159 842H234V758H159V842Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uE308",
    horizAdvX: 222,
    d: "M49 816Q49 790 67 775Q84 757 109 757Q135 757 152 775Q169 790 169 816Q169 842 152 859Q135 875 109 875Q84 875 67 859Q49 842 49 816ZM13 816Q13 858 41 884Q68 910 109 911Q150 910 178 884Q204 858 205 816Q204 775 178 749Q150 721 109 721Q68 721 41 749Q13 775 13 816Z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "T",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "W",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "Y",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "w",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "y",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xDD",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xFD",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xFF",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0178",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u2019",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ",",
    k: 129
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ".",
    k: 129
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "A",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC0",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC1",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC2",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC3",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC4",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC5",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "T",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "V",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "W",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "Y",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "y",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xDD",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xFD",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xFF",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u0178",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u2019",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ",",
    k: 153
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ".",
    k: 153
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "A",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC0",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC1",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC2",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC3",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC4",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC5",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "T",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "V",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "W",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "Y",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "y",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xDD",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xFD",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xFF",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0178",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ",",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "-",
    k: 129
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ".",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ":",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ";",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "A",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "a",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "c",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "e",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "i",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "o",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "r",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "s",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "u",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "w",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "y",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC0",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC1",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC2",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC3",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC4",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC5",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE0",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE1",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE2",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE3",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE4",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE5",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE7",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE8",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE9",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xEA",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xEB",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xEC",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xED",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xEE",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xEF",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF2",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF3",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF4",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF5",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF6",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF9",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xFA",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xFB",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xFC",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xFD",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xFF",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0161",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ",",
    k: 129
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "-",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ".",
    k: 129
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ":",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ";",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "A",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "a",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "e",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "i",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "o",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "r",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "u",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "y",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC0",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC1",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC2",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC3",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC4",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC5",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE0",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE1",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE2",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE3",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE4",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE5",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE8",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE9",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEA",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEB",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEC",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xED",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEE",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEF",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF2",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF3",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF4",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF5",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF6",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF9",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFA",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFB",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFD",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFF",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ",",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ".",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ":",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ";",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "A",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "a",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "e",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "i",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "o",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "r",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "u",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC0",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC1",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC2",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC3",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC4",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC5",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE0",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE1",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE3",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE4",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE5",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE8",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE9",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xEA",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xEB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xEC",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xED",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xEE",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xEF",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF2",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF3",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF4",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF5",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF6",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF9",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xFA",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xFB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xFC",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ",",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "-",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ".",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ":",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ";",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "A",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "a",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "e",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "i",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "o",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "p",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "q",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "u",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "v",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC0",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC1",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC2",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC3",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC4",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC5",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE0",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE1",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE2",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE3",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE4",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE5",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE8",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE9",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xEA",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xEB",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xEC",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xED",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xEE",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xEF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF2",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF3",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF4",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF5",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF6",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF9",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xFA",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xFB",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xFC",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "f",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u2019",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: ",",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "-",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: ".",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "c",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "d",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "e",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "n",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "o",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "q",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xE7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xE8",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xE9",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xEA",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xEB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xF1",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xF2",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xF3",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xF4",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xF5",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xF6",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ",",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ".",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: ",",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: ".",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: ",",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: ".",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "T",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "W",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "Y",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "w",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "y",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xDD",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xFD",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xFF",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u0178",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u2019",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "T",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "W",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "Y",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "w",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "y",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xDD",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xFD",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xFF",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u0178",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u2019",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "T",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "W",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "Y",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "w",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "y",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xDD",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xFD",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xFF",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u0178",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u2019",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "T",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "W",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "Y",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "w",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "y",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xDD",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xFD",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xFF",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u0178",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u2019",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "T",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "W",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "Y",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "w",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "y",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xDD",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xFD",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xFF",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u0178",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u2019",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "T",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "W",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "Y",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "w",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "y",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xDD",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xFD",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xFF",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u0178",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u2019",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: ",",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "-",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: ".",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: ":",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: ";",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "A",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "a",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "e",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "i",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "o",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "p",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "q",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "u",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "v",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC0",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC1",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC2",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC3",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC4",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC5",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE0",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE1",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE2",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE3",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE4",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE5",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE8",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE9",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xEA",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xEB",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xEC",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xED",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xEE",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xEF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF2",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF3",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF4",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF5",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF6",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF9",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xFA",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xFB",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xFC",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFD",
    u2: ",",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFD",
    u2: ".",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: ",",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: ".",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: ",",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "-",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: ".",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: ":",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: ";",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "A",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "a",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "e",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "i",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "o",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "p",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "q",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "u",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "v",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xC0",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xC1",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xC2",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xC3",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xC4",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xC5",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE0",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE1",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE2",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE3",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE4",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE5",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE8",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE9",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xEA",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xEB",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xEC",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xED",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xEE",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xEF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xF2",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xF3",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xF4",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xF5",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xF6",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xF9",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xFA",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xFB",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xFC",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u2018",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "s",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0161",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u2019",
    k: 102
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFrutiger45Light);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/frutiger-45light.105ffe8d83458d0f57464421b62445e2.svg";